/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/InstallmentCharge/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let entryCreatedByUserPersonValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_by_user.person',
format: fromFormat.personName,
})
let entryCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_at',
format: fromFormat.dateShortWithMonthAndTime,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-9-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-10-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-11-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 weight="medium"
 text="Metadata"
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Created by"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.created_by_user.person"
 format="/Data/format.js personName"
 text={entryCreatedByUserPersonValueData}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Created at"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.created_at"
 format="/Data/format.js dateShortWithMonthAndTime"
 text={entryCreatedAtValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}